/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FintectureCredentialsRequest = {
    customer_id: number;
    app_id: string;
    app_id_secret: string;
    app_priv_key: string;
    env: FintectureCredentialsRequest.env;
    agence_id?: number | null;
};
export namespace FintectureCredentialsRequest {
    export enum env {
        SANDBOX = 'sandbox',
        PRODUCTION = 'production',
    }
}

